import React, { createContext, useContext, RefObject } from 'react';

const MenuBottomActionsContext = createContext<RefObject<HTMLDivElement> | null>(null);

export const MenuBottomActionsProvider = MenuBottomActionsContext.Provider;

export const useMenuBottomActionsRef = () => {
  const context = useContext(MenuBottomActionsContext);
  if (!context) {
    throw new Error('useMenuBottomActionsRef must be used within MenuBottomActionsProvider');
  }
  return context;
};
